import { AccessReportDto } from '../common/interfaces/AccessReportDto';
import httpClient from './HttpClient';

export const getAccessReport = async (): Promise<AccessReportDto> => {
    const response = await httpClient.post<AccessReportDto, void>('/report/view-access');

    return response.data;
};
